import { render, staticRenderFns } from "./MyPagination.vue?vue&type=template&id=ad5e34ee&"
import script from "./MyPagination.vue?vue&type=script&lang=js&"
export * from "./MyPagination.vue?vue&type=script&lang=js&"
import style0 from "./MyPagination.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports